export default __webpack_public_path__ + "static/media/rectangle3.c2541d99.svg";